import React, { Fragment } from "react"
import { ErrorMessageComp } from "./errorMsgStyle";
import PropTypes from 'prop-types';

function ErrorMessage({ message }) {
    return ( <ErrorMessageComp>
            {message}
        </ErrorMessageComp>
 )
}
ErrorMessage.propTypes = {
  message: PropTypes.string.isRequired, // Add this line
};
export default ErrorMessage;